module.exports = __webpack_public_path__ + "static/main_pic_02-cf5182823977527ea47082e8415b1ae4.jpg";